import type { ModalProps } from '@boostbrothers/web-ui/web';
import { atom, useAtom } from 'jotai';

const modalAtom = atom<ModalProps>({ isOpened: false });

const useModal = () => {
  const [modalInfo, setModalInfo] = useAtom(modalAtom);

  const openModal = ({ modalContent }: Omit<ModalProps, 'isOpened'>) => {
    setModalInfo({ isOpened: true, modalContent });
  };

  const closeModal = () => {
    setModalInfo({ isOpened: false });
  };

  return {
    modalInfo,
    openModal,
    closeModal,
  };
};

export default useModal;
